import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import API from "../../Network/API";
import Agent from "../../Network/Agent";
import { RMS_STATUS_FETCH_START } from "../../Reducer/RmsStatusSlice";
import NProgress from 'nprogress';
export default function RmsStatusFilter({ callbackSearch }) {
  const selector_cluster = useSelector((state) => state.clusterReducer);
  const tenants = useSelector((state) => state.tenantReducer)
  const [options, setOption] = useState([])
  const [options2, setOption2] = useState([])
  const [resetKey, setResetKey] = useState(0);
  const [cluster_id, setClusterId] = useState('');
  const modalRef1 = useRef()
  const [zone_id, setZoneId] = useState('');
  const dispatch = useDispatch();

  const array_data = {
    'page': 1,
    'site_id': "",
    'tenant_id': "",
    'cluster': "",
    'zone': "",
    'filter_type': "",
  }
  const searchZone = (e) => {
    setOption2([])
    if (!e) {
      setClusterId('');
      setOption2([])
      return;
    }
    setClusterId(e?.value)
    console.log("Cluster ID:", e.value);
    API.get(`/v1/oauth/ajax_cluster_zone/${e.value}`).then((response) => {
      setOption2(response.data.data.zone)
    }).catch((error) => {

    });
  }

  const searchZoneSite = (e) => {

    if (!e) {
      setZoneId('');
      return;
    }
    setZoneId(e?.value)
  }

  useEffect(() => {
    if (selector_cluster?.data && Array.isArray(selector_cluster.data)) {
      const newOptions = selector_cluster?.data?.map(item => ({
        value: item.id.toString(), // Assuming you want the ID as a string
        label: item.name
      }));
      setOption(newOptions);
    } else {
      setOption([]); // Optional: clear options if data is not available
    }
  }, [selector_cluster]);


  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log(event.target.siteId.value)
    array_data.site_id = event.target.siteId.value;
    array_data.cluster = cluster_id;
    array_data.zone = zone_id;
    array_data.filter_type = event.target.filter_type.value;
    array_data.tenant_id = event.target.tenant.value;
    array_data.page = 1;
    NProgress.start();
    dispatch(RMS_STATUS_FETCH_START())
    Agent.All_RMS_STATUS.all(dispatch, array_data).finally(
       NProgress.done()
    );
    callbackSearch(array_data)
  }

  return (
    <>
      <div className="dropdown d-inline-block ms-2">
        <button className="input-group-text"
          type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa-solid fa-filter"></i> Filter
        </button>

        <div className="dropdown-menu p-2 shadow" aria-labelledby="dropdownMenuButton2" onClick={(e) => e.stopPropagation()}>
          <div style={{ width: '400px' }}>

            <h5 className='card-title border-bottom pb-2'>Filter</h5>
            <form ref={modalRef1} onSubmit={handleSubmit} id="add_country_form">
              {/* //alarm time asc/desc */}

              <div className='row'>
                <div className="form-group  mb-2 col-md-12">
                  <label className="form-label fs-7">Site ID/Customer Site ID</label>
                  <input type="text" name="siteId" className="form-control form-control-sm" placeholder="Search by site or customer site" />
                </div>
                <div className="form-group  mb-2 col-md-6">
                  <label className="form-label fs-7">Cluster</label>
                  <Select key={resetKey} onChange={searchZone} name="cluster" isClearable closeMenuOnSelect={true} options={options} />

                </div>
                <div className="form-group mb-2 col-md-6">
                  <label className="form-label fs-7">Zone</label>
                  <Select key={resetKey} onChange={searchZoneSite} name="zone" isClearable closeMenuOnSelect={true} options={options2} />

                </div>
              </div>

              <div className="form-group mb-2">
                <label className="form-label fs-7">Tenant</label>
                <select name="tenant" className='form-select form-select-sm'>
                  <option value="">All Tenants</option>
                  {tenants?.data?.length > 0 && tenants?.data?.map((tenant, indexI) => (
                    <option value={tenant.id}>{tenant.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group mb-2">
                <label className="form-label fs-7">Filter Types</label>
                <select className='form-select form-select-sm' name="filter_type">
                  <option value={``}>All</option>
                  <option value={`1`}>Alarm Trend Over Time</option>
                  <option value={`2`}>Alarm Trend Site Down</option>
                  <option value={`3`}>Alarm Gap Detection </option>
                  <option value={`4`}>Sites on Critical Alarms</option>
                  <option value={`5`}>Top Mains Fail Alarm Sites</option>

                </select>
              </div>

              <button type="submit" className="btn btn-primary btn-sm">Apply Filter</button>
            </form>
          </div>



        </div>
      </div>
    </>
  )
}